
export const getContacts = (state) => state.contacts

export const getClientId = function (state) {
    return state.clientId
}

export const getCountries = function(state){
    return state.countries
}

export const getSelectedContact = (state) => {
    return state.contacts.filter(contact => contact.id === state.clientId)[0]
}

export const getStates = function(state){
        return state.states
}

export const getCities = function(state){
    return state.cities
}

export const getStreets = function(state){
        return state.streets
    }


